module.exports = __webpack_public_path__ + "media/images/favicon-2e85913a4b0496ed9b27885782a9bb09.png";